import React, { useState, useEffect, useRef } from 'react';

const Stopwatch = () => {
  const [remainingTime, setRemainingTime] = useState(0); // in ms
  const [isRunning, setIsRunning] = useState(true);
  const timeoutRef = useRef(null);

  const SESSION_START_KEY = 'stopwatch_start_time';
  const SESSION_END_KEY = 'stopwatch_end_time';

  useEffect(() => {
    const now = Date.now();
    let startTime: any = sessionStorage.getItem(SESSION_START_KEY);
    let endTime: any = sessionStorage.getItem(SESSION_END_KEY);

    if (!startTime || !endTime) {
      startTime = now;
      endTime = now + 60 * 60 * 1000; // 1 hour from now
      sessionStorage.setItem(SESSION_START_KEY, startTime);
      sessionStorage.setItem(SESSION_END_KEY, endTime);
    }

    startTime = parseInt(startTime, 10);
    endTime = parseInt(endTime, 10);

    const initialRemaining = endTime - now;
    setRemainingTime(initialRemaining);

    if (initialRemaining <= 0) {
      handleStop();
      return;
    }

    setIsRunning(true);
    tick(endTime);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const tick = (endTime) => {
    timeoutRef.current = setTimeout(() => {
      const now = Date.now();
      const newRemaining = endTime - now;

      if (newRemaining <= 0) {
        setRemainingTime(0);
        handleStop();
      } else {
        setRemainingTime(newRemaining);
        tick(endTime);
      }
    }, 1000); // update every second
  };

  const handleStop = () => {
    setIsRunning(false);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    console.log('Countdown finished. Triggering final action.');
    // Example:
    // axios.post('/api/submit', { timeUsed: 3600000 - remainingTime });
  };

  const formatTime = (ms) => {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className='rounded-xl border border-[gray] py-1 px-2'>
      <h2>{formatTime(remainingTime)}</h2>
    </div>
  );
};

export default Stopwatch;
